import { useNumberFormatter } from '@fv/client-core'
import type { PropsWithClassName } from '@fv/client-types'
import type { Currency } from '@fv/models'

type Props = PropsWithClassName<{
  val: number | string | undefined | null
  currency?: Currency
  includeEmptyDecimals?: boolean
  precision?: number
  showCurrencyCode?: boolean
}>
export const FvNum = ({
  val,
  currency,
  includeEmptyDecimals,
  className,
  precision = 2,
  showCurrencyCode = true,
}: Props) => {
  const formatter = useNumberFormatter({
    currency,
    includeEmptyDecimals,
    precision,
  })
  if (val === undefined || val === null) return ''
  return (
    <span className={className}>
      {formatter(val)}
      {currency && showCurrencyCode && (
        <span className="text-xs ml-1">{currency.toUpperCase()}</span>
      )}
    </span>
  )
}
